<template>
	<div>
		<v-simple-table dense class="background-2">
			<thead>
				<tr>
					<th>Campo GMH</th>
					<th>Campo AISA</th>
					<th>Traduzione dei valori</th>
					<th class="text-center">Invia</th>
					<th class="text-center">Aggiorna da AISA</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(riga, i) in value" :key="i">
					<td style="min-width: 220px">
						<v-autocomplete dense hide-details :items="campiGmh" item-text="etichetta" item-value="campo" :value="riga.campo" @change="aggiorna(i, 'campo', $event)"></v-autocomplete>
					</td>
					<td style="min-width: 220px">
						<v-autocomplete dense hide-details :items="catalogo" item-text="etichetta" item-value="chiave" :value="riga.aisa" @change="aggiorna(i, 'aisa', $event)"></v-autocomplete>
					</td>
					<td>
						<template v-if="valoriAisa(riga).length">
							<div v-for="opzione in opzioniGmh(riga)" :key="opzione.value" class="d-flex align-center">
								<span class="mr-2" style="min-width: 140px">{{ opzione.text }}</span>
								<v-select dense hide-details clearable :items="valoriAisa(riga)" :value="(riga.valori || {})[opzione.value]" @change="aggiornaValore(i, opzione.value, $event)"></v-select>
							</div>
							<span v-if="!opzioniGmh(riga).length" class="caption">Il campo GMH non ha valori a elenco: si inviano solo i valori già uguali a quelli AISA</span>
						</template>
						<span v-else class="caption">-</span>
					</td>
					<td class="text-center">
						<v-simple-checkbox :value="!!riga.invia" @input="aggiorna(i, 'invia', $event)"></v-simple-checkbox>
					</td>
					<td class="text-center">
						<v-simple-checkbox :value="!!riga.aggiorna" @input="aggiorna(i, 'aggiorna', $event)"></v-simple-checkbox>
					</td>
					<td>
						<v-btn icon small @click="rimuovi(i)"><v-icon small>mdi-delete</v-icon></v-btn>
					</td>
				</tr>
			</tbody>
		</v-simple-table>
		<v-btn text color="primary" class="mt-2" @click="aggiungi">
			<v-icon left>mdi-plus</v-icon>
			Aggiungi campo
		</v-btn>
	</div>
</template>

<script>
export default {
	name: 'aisa-mappatura',
	props: {
		value: { type: Array, default: () => [] },
		catalogo: { type: Array, default: () => [] },
		campiGmh: { type: Array, default: () => [] },
	},
	methods: {
		emetti(righe) {
			this.$emit('input', righe)
		},
		aggiungi() {
			this.emetti(this.value.concat([{ campo: null, aisa: null, valori: {}, invia: true, aggiorna: false }]))
		},
		rimuovi(i) {
			this.emetti(this.value.filter((r, j) => j !== i))
		},
		aggiorna(i, chiave, valore) {
			const righe = this.value.map((r, j) => j === i ? Object.assign({}, r, { [chiave]: valore }) : r)
			if (chiave === 'aisa' || chiave === 'campo') {
				righe[i].valori = {}
			}
			this.emetti(righe)
		},
		aggiornaValore(i, valoreGmh, valoreAisa) {
			const valori = Object.assign({}, this.value[i].valori || {})
			if (valoreAisa === null || valoreAisa === undefined) {
				delete valori[valoreGmh]
			} else {
				valori[valoreGmh] = valoreAisa
			}
			this.aggiorna(i, 'valori', valori)
		},
		valoriAisa(riga) {
			const voce = this.catalogo.find(c => c.chiave === riga.aisa)
			return voce && voce.tipo === 'enum' ? voce.valori : []
		},
		opzioniGmh(riga) {
			const campo = this.campiGmh.find(c => c.campo === riga.campo)
			return campo && Array.isArray(campo.opzioni) ? campo.opzioni : []
		},
	},
}
</script>
